
import { ValidationMessages } from '@/utils/validation/validationMessages';
import { RegisterOptions } from 'react-hook-form';
import { FormInputProps } from './FormInput';

// Map inputType to HTML inputMode attribute
export const InputModeMap: Record<
  FormInputProps['inputType'], 
  React.HTMLAttributes<HTMLInputElement>['inputMode']
> = {
  'numeric': 'numeric',
  'decimal': 'numeric',
  'tel': 'tel',
  'email': 'email',
  'url': 'url',
  'alphabets': 'text',
  'text': 'text'
};

// Map inputType to HTML input type attribute
export const InputTypeMap: Record<FormInputProps['inputType'], string> = {
  'numeric': 'text',
  'decimal': 'text',
  'alphabets': 'text',
  'tel': 'tel',
  'email': 'email',
  'url': 'url',
  'text': 'text'
};

// Generate validation rules based on inputType
export const getValidationRules = (
  inputType: FormInputProps['inputType'] = 'text', 
  isRequired: boolean = false
): RegisterOptions => {
  const validation: RegisterOptions = {};
  
  if (isRequired) {
    validation.required = ValidationMessages.required.toString();
  }

  switch (inputType) {
    case 'alphabets':
      validation.pattern = {
        value: /^[a-zA-Z\s]*$/,
        message: ValidationMessages.alphabetsOnly.toString()
      };
      break;
    case 'numeric':
      validation.pattern = {
        value: /^[0-9]*$/,
        message: ValidationMessages.numbersOnly.toString()
      };
      break;
    case 'decimal':
      validation.pattern = {
        value: /^[0-9]*\.?[0-9]*$/,
        message: "Please enter a valid number"
      };
      break;
    case 'email':
      validation.pattern = {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Please enter a valid email address"
      };
      break;
    case 'url':
      validation.pattern = {
        value: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
        message: "Please enter a valid URL"
      };
      break;
  }
  
  return validation;
};
